/* global Vimeo */
import $ from 'jquery'
import 'magnific-popup'
import './classes/polyfills.class.js'
import ScrollBar from './classes/simplebar.js'
import AnchorScroller from './classes/anchor-scroller'
import AOS from 'aos'
import CollapsibleItem from './classes/collapsible-item.class.js'
import ResourcesLang from './classes/resources-lang.class.js'
import FixedHeader from './classes/fixed-header.class'
import FixedIsi from './classes/fixed-isi.js'
import FormBehavior from './classes/form-behavior.class.js'
import MainMenu from './classes/main-menu.class.js'
import Carousel from './classes/carousel.class.js'
import Modal from './classes/modal.class.js'
import Violator from './classes/violator.class'
import PatientEducationFinder from './features/zipcode-finder/index.js'

// Initialize Animate on Scroll
AOS.init({
  duration: 1200,
  once: true
})

if (!getCookie('landing-url') && location.search)
  setCookie('landing-url', location.href, 5*24)

// Expose SimpleBar class for SDC components (e.g. modal-button) that need programmatic init
window.SimpleBar = ScrollBar.SimpleBar;

if (document.querySelector('.fixed .row'))
  new ScrollBar(document.querySelector('.fixed .row'))

if (document.querySelector('#popup-trial-study')) {
  new ScrollBar(document.querySelector('#popup-trial-study .layout--onecol'))
}

// Initialize AnchorScroller.
// In-page anchors (including #isi) must land below the sticky header with Day 1
// spacing. The original offset was menu-container height + 70 (desktop) or + 120
// (mobile). TRYN-1139 fixed measuring only the utility bar but replaced those
// gaps with HEADER_GAP = 16, which pulled #isi under the dual logo. The header
// footprint also exceeds .dual-branding's box because the arc/wings overflow.
//
// measureHeaderBottom() returns the lowest visible edge of the pinned header
// stack; stableHeaderBottom is captured on load/resize while mobile menus are
// closed so a menu-open click does not under-measure the branding row.
const DESKTOP_ANCHOR_GAP = 140
const MOBILE_ANCHOR_GAP = 120
const ANCHOR_BREAKPOINT = 768

const isMobileMenuOpen = () =>
  document.body.classList.contains('dual-menu-open') ||
  Boolean(document.querySelector('.hamburger.active')) ||
  Boolean(document.querySelector('.dual-mobile-topmenu.is-open'))

const measureHeaderBottom = () => {
  const header = document.querySelector('header[role=banner]')
  if (!header) {
    return 0
  }

  const nodes = [header]
  header
    .querySelectorAll('.dual-branding, .dual-branding__arc, .dual-branding__wings, .shtg-branding')
    .forEach(el => nodes.push(el))

  let bottom = 0
  nodes.forEach(el => {
    const rect = el.getBoundingClientRect()
    if (rect.height > 0 && rect.bottom > 0) {
      bottom = Math.max(bottom, rect.bottom)
    }
  })

  if (bottom <= 0) {
    const rect = header.getBoundingClientRect()
    bottom = Math.max(rect.bottom > 0 ? rect.bottom : 0, header.offsetHeight)
  }
  return bottom
}

let stableHeaderBottom = measureHeaderBottom()
const refreshStableHeaderBottom = () => {
  if (!isMobileMenuOpen()) {
    stableHeaderBottom = measureHeaderBottom()
  }
}
$(refreshStableHeaderBottom)
$(window).on('load resize orientationchange', refreshStableHeaderBottom)

const headerBottom = () => Math.max(measureHeaderBottom(), stableHeaderBottom)
const desktopAnchorOffset = () => headerBottom() + DESKTOP_ANCHOR_GAP
const mobileAnchorOffset = () => headerBottom() + MOBILE_ANCHOR_GAP
const scroll = new AnchorScroller(desktopAnchorOffset, mobileAnchorOffset, ANCHOR_BREAKPOINT)
scroll.init()


// Initialize Modal Class
new Modal()

// Each initializer below is independent, but they share one ready handler: an
// uncaught throw in any of them silently skips every initializer after it.
function safeInit(label, fn) {
  try {
    fn()
  }
  catch (error) {
    console.error(`Failed to initialize ${label}:`, error)
  }
}

$(() => {
  // Prevent scroll to modal after click
  $('a').each(function () {
    const href = $(this).attr('href')

    if (
      typeof href !== 'undefined'
      && href.startsWith('#')
      && $(this).hasClass('block--type--modal')
    ) {
      $(this).on('click', (e)=> e.stopImmediatePropagation())
    }
  })

  $('[link^="_blank"]').on('click', function(event) {
    event.preventDefault()

    if ($(this).attr('href').includes('.pdf'))
      window.open($(this).attr('href'), '_blank')
  })

  safeInit('FixedIsi', () => {
    const isi = document.querySelector('.isi .fixed')
    if (isi) {
      new FixedIsi()
    }
  })

  safeInit('Violator', () => {
    const violator = document.querySelector('.violator')
    if (violator) {
      new Violator(violator)
    }
  })

  safeInit('FixedHeader', () => {
    new FixedHeader()
  })

  safeInit('MainMenu', () => {
    const mainMenu = document.querySelector('.layout-container > header')
    if (mainMenu) {
      new MainMenu(mainMenu)
    }
  })

  safeInit('hero carousel', () => {
    if ($('.hero-carousel').length) {
      var total = $('.hero-carousel video').length || $('.hero-carousel img').length,
        rand = Math.floor( Math.random() * total )

      $('.hero-carousel').slick({
        accessibility: true,
        arrows: false,
        dots: false,
        speed: 1000,
        mobileFirst: true,
        fade: true,
        autoplay: false,
        autoplaySpeed: 5000,
        initialSlide: rand
      })
    }
  })

  if ($('.resource').length) {
    $('.resource').on('click', function(event) {
      // If the click is on an anchor tag or its child, don't do anything
      if ($(event.target).closest('a', this).length > 0) {
        return
      }

      event.preventDefault()

      if ($(this).hasClass('download')) {
        window.open($(this).find('a').attr('href'), '_blank')
      }

      if ($(this).hasClass('website'))
        $(this).find('a').trigger('click')
    })
  }

  // Don't active slideshows on the Layout Builder page
  safeInit('Carousel', () => {
    if (
      $('.block--type--carousel-slide').length
      && !$('.node-page-layout-builder-form').length
    ) {
      $.uniqueSort(
        $('.block--type--carousel-slide')
          .parents('.layout__region')
      )
        .css({
          'min-width': 0
        })
        .each(function () {
          new Carousel(this)
        })
    }
  })

  safeInit('FormBehavior', () => {
    document.querySelectorAll('.webform-submission-form').forEach(f => {
      new FormBehavior(f)
    })
  })

  safeInit('CollapsibleItem', () => {
    document.querySelectorAll('.block--type--collapsible-item').forEach(item => {
      new CollapsibleItem(item)
    })
  })

  // Also self-initializes on DOMContentLoaded and via Drupal.behaviors, and
  // handles clicks through delegation, so the tabs no longer depend on this
  // handler being reached at all.
  safeInit('ResourcesLang', () => {
    document.querySelectorAll('[data-component="resources-lang"]').forEach(el => {
      new ResourcesLang(el)
    })
  })

  // Initialize Patient Education Finder components
  document.querySelectorAll('[data-component="patient-education-finder"]').forEach(element => {
    try {
      const config = element.dataset.config ? JSON.parse(element.dataset.config) : {}
      new PatientEducationFinder(element, config)
    } catch (error) {
      console.error('Failed to initialize Patient Education Finder:', error)
    }
  })

  if ($('.popup-youtube').length) {
    $('.popup-youtube').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1&modestbranding=1'
          }
        }
      },
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    })
  }

  // === Vimeo Video Switch on Click ===
  const nextVideos = document.querySelectorAll('.next-video')
  const videoIframes = document.querySelectorAll('.main-video-container .video')
  const videoDetails = document.querySelectorAll('.about-video-container')
  const transcriptDetails = document.querySelectorAll('.transcript-container')

  const playersByIndex = {}

  if (window.Vimeo && Vimeo.Player) {
    document.querySelectorAll('iframe[id^="mainIframe-"]').forEach((iframe) => {
      const idx = Number(iframe.id.replace('mainIframe-', ''))
      if (Number.isInteger(idx)) {
        playersByIndex[idx] = new Vimeo.Player(iframe)
      } else {
        console.warn(`Invalid iframe ID format: ${iframe.id}`)
      }
    })
  } else {
    console.warn('Vimeo API not available yet; skipping player init')
  }


  nextVideos.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      const videoIndex = Number(this.dataset.videoIndex)
      if (!Number.isInteger(videoIndex)) return

      // Pause all players safely
      Object.values(playersByIndex).forEach((player) => {
        player.pause?.().catch(() => {})
      })


      // Hide all videos and details
      videoIframes.forEach((el) => el.classList.add('hidden'))
      videoDetails.forEach((el) => el.classList.add('hidden'))
      transcriptDetails.forEach((el) => el.classList.add('hidden'))

      // Show selected video and details
      const selectedIframe = document.querySelector(`#mainIframe-${videoIndex}`).parentElement
      const selectedDetails = document.querySelector(`.video-details-${videoIndex}`)
      const selectedTranscript = document.querySelector(`.transcript-details-${videoIndex}`)

      const headerOffset = 120
      if (selectedIframe) {
        selectedIframe.classList.remove('hidden')
        // Scroll to video position with offset
        const elementPosition = selectedIframe.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }

      if (selectedDetails) selectedDetails.classList.remove('hidden')
      if (selectedTranscript) selectedTranscript.classList.remove('hidden')

      // Manage active class on thumbnails
      nextVideos.forEach(function (el) {
        el.classList.remove('active')
      })
      this.classList.add('active')

      // Reset selected video to start
      const selectedPlayer = playersByIndex?.[videoIndex]
      selectedPlayer?.setCurrentTime?.(0).catch(() => {})
    })
  })

  // Check for requested video from URL parameter on page load
  const videoSection = document.querySelector('.video-section')
  if (videoSection) {
    // Get URL parameters directly from window.location
    const urlParams = new URLSearchParams(window.location.search)
    const requestedVideo = urlParams.get('video')
    const videoMapping = JSON.parse(videoSection.getAttribute('data-video-mapping') || '{}')

    if (requestedVideo) {
      let videoIndex = null

      // Check if it's a name (genevie, aaron)
      if (videoMapping[requestedVideo] !== undefined) {
        videoIndex = videoMapping[requestedVideo]
      }
      // Check if it's a numeric index
      else if (!isNaN(requestedVideo)) {
        videoIndex = parseInt(requestedVideo)
      }

      // If we have a valid video index, trigger the click on that video
      if (videoIndex !== null && videoIndex >= 0) {
        const targetVideo = document.querySelector(`.next-video[data-video-index="${videoIndex}"]`)
        if (targetVideo) {
          // Small delay to ensure all elements are properly initialized
          setTimeout(() => {
            targetVideo.click()
          }, 100)
        }
      }
    }
  }
})

function setCookie(name,value,hours) {
  var expires = ''
  if (hours) {
    var date = new Date()
    date.setTime(date.getTime() + (hours*60*60*1000))
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '')  + expires + '; path=/'
}
function getCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for(var i=0;i < ca.length;i++) {
    var c = ca[i]
    while (c.charAt(0)==' ') c = c.substring(1,c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length)
  }
  return null
}
